import { connect } from 'react-redux';
import * as R from 'ramda';
import HeaderButtons from './HeaderButtons';
import { getFilterIdentifierCount } from '../../../filters/store/filtersSlice';

import {
  getCurrentSelection,
  setDialogDetails,
  toggleBatchActivation,
} from '../../store/supplierAuthorizationSlice';

const mapState = state => ({
  activeSupplierAuthTab: state.loadingManagement.supplierAuthorizations.activeSupplierAuthTab,
  filterIdentifierCount: getFilterIdentifierCount(state),
  nameShort: R.o(R.prop('nameShort'), getCurrentSelection)(state),
  supplierAuthorizationsCards:
    state.loadingManagement.supplierAuthorizations.supplierAuthorizationsCards,
  supplierAuthorizationsPending:
    state.loadingManagement.supplierAuthorizations.supplierAuthorizationsPending,
});

const mapDispatchToProps = {
  setDialogDetails,
  toggleBatchActivation,
};

export default connect(mapState, mapDispatchToProps)(HeaderButtons);
